export default "__VITE_ASSET__0b4379a7__"